import { CellPos, GridDesignerData } from '../grid-designer';
import type { InputCellSetting, TableSize } from './types';

class CustomInputService {

  /**
   * 坐标转换为字符串 0,0 => A1
   */
  posToString(pos: CellPos): string {
    const columnLetter = String.fromCharCode('A'.charCodeAt(0) + pos.col);
    return `${columnLetter}${pos.row + 1}`;
  }

  /**
   * A1 => 0,0
   */
  stringToPos(key: string): CellPos {
    const col = key.charCodeAt(0) - 'A'.charCodeAt(0);
    const row = parseInt(key.slice(1), 10) - 1;
    return { col, row };
  }

  /**
   * 数据格式转换
   * { "A1": { "empty": "yes" } } => { option: [ [ { empty: "yes" } ] ], gridCol: 1, gridRow: 1 }
   */
  toTableValue(value?: Record<string, InputCellSetting>): GridDesignerData {
    if (value == null) {
      return {};
    }

    const keys = Object.keys(value);
    const size = this.getOptionArraySize(keys);
    const result = service.initOptionArray(size);

    for (const key of keys) {
      const pos = service.stringToPos(key);
      result[pos.row][pos.col] = value[key];
    }

    return {
      option: result,
      gridCol: result[0].length,
      gridRow: result.length
    };
  }

  /**
   * 数据格式转换
   * [ [ { empty: "yes" } ] ] => { "A1": { "empty": "yes" } }
   */
  toFormValue(value?: InputCellSetting[][]): Record<string, InputCellSetting> {
    if (value == null) {
      return {};
    }

    const result: Record<string, InputCellSetting> = {};
    for (const [rowIndex, row] of value.entries()) {
      for (const [colIndex, col] of row.entries()) {
        const key = this.posToString({ col: colIndex, row: rowIndex });
        result[key] = col;
      }
    }
    return result;
  }

  private getOptionArraySize(keys: string[]): TableSize {
    let maxRow = 0;
    let maxCol = 0;

    for (const key of keys) {
      const pos = this.stringToPos(key);
      maxRow = Math.max(maxRow, pos.row);
      maxCol = Math.max(maxCol, pos.col);
    }
    return { gridCol: maxCol + 1, gridRow: maxRow + 1 };
  }

  private initOptionArray(size: TableSize): InputCellSetting[][] {
    return Array
      .from({ length: size.gridRow })
      .map(() => Array.from({ length: size.gridCol }));
  }

}

export const service = new CustomInputService();
